<template>
  <div>
    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <Table :ticketHistories="ticketHistories"/>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Table from '@/components/admin/maestro/ticket_history/Table'
import Pagination from '@/components/shares/specialTag/Pagination'
import ModelMapper from '@/mixins/ModelMapper'

export default {
  components: { Pagination, Table },
  computed: {
    ticketHistories() {
      return this.getModels || []
    }
  },
  created() {
    this.addOrderBy('createdAt')

    const date = new Date()
    date.setDate(date.getDate())

    this.find()
  },
  data: () => ({
    nameModel: 'Request',
  }),
  methods: {
    buildPath() {
      return `admin/maestro/tickets/${this.ticket.id}/histories`
    },
    find() {
      this.asyncTemplateSelect()
    }
  },
  mixins: [ModelMapper],
  name: 'TicketHistories',
  props: {
    ticket: {
      required: true,
      type: Object
    }
  }
}

</script>

<style scoped>

</style>